<template>
  <IModal v-model="isShow" :destroy-on-close="true" :fullscreen="true" :with-close-button="false">
    <div :class="$style.wrapper">
      <SigninSignupForm v-model="activeRef" :is-modal="true" :from="from" @submit="onSubmit" @close="onClose" />
    </div>
  </IModal>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useUserStore } from '@/js/lib/store/user';
import IModal from '@/js/components/molecules/IModal.vue';
import SigninSignupForm from '@/js/components/www.iichi.com/pages/signin-signup/SigninSignupForm.vue';

const props = withDefaults(
  defineProps<{
    active?: string;
    next?: string;
    callback?: () => void;
  }>(),
  {
    active: '',
    next: '',
    callback: () => {},
  },
);
const userStore = useUserStore();
const isShow = ref(false);
const activeRef = ref('signin');
const from = ref('');
const onClose = () => {
  isShow.value = false;
};
const onSubmit = () => {
  if (props.callback) {
    props.callback();
  }
};

onMounted(() => {
  activeRef.value = props.active || (userStore.hasSignined ? 'signin' : 'signup');
  from.value = props.next;
  isShow.value = true;
});
</script>

<style module lang="scss">
.wrapper {
  width: 100vw;
}
</style>
